<template>
<div> 
    <div style="padding:20px 20px 13px 20px;margin-bottom: 20px;border: 1px solid #C9D6E7;border-radius: 8px;background: #FFF;" v-for="n in 4" :key="n">
        <svg viewBox="0 0 600 101" version="1.1" preserveAspectRatio="xMidYMid meet">
        <rect clip-path="url(#flightloader)" x="0" y="0" width="600" height="101" style="fill: url(&quot;#7nu3ny6oj18&quot;);"></rect>
        <defs> 
            <clipPath id="flightloader">
            <rect cx="18" cy="18" r="18"></rect>
            <rect x="0" y="0" rx="3" ry="3" width="45" height="45"></rect>
            <rect x="60" y="5" rx="3" ry="3" width="250" height="12"></rect>        
            <rect x="400" y="5" rx="3" ry="3" width="200" height="8"></rect>
            <rect x="60" y="32" rx="3" ry="3" width="220" height="8"></rect>
            <rect x="430" y="32" rx="3" ry="3" width="170" height="8"></rect>
            <rect x="0" y="65" rx="3" ry="3" width="100%" height="1"></rect>
            <rect x="0" y="85" rx="3" ry="3" width="190" height="8"></rect>
            <rect x="500" y="75" rx="3" ry="3" width="100" height="26"></rect>
            </clipPath>
            <linearGradient id="7nu3ny6oj18">
            <stop offset="0.449662" stop-color="#C9D6E7">
                <animate attributeName="offset" values="-2; 1" dur="2s" repeatCount="indefinite"></animate>
            </stop>
            <stop offset="0.949662" stop-color="#b4c4d9">
                <animate attributeName="offset" values="-1.5; 1.5" dur="1.8s" repeatCount="indefinite"></animate>
            </stop>
            <stop offset="1.44966" stop-color="#C9D6E7">
                <animate attributeName="offset" values="-1; 2" dur="2s" repeatCount="indefinite"></animate>
            </stop>
            <stop offset="1.44966" stop-color="#C9D6E7">
                <animate attributeName="offset" values="-1; 2" dur="2s" repeatCount="indefinite"></animate>
            </stop>
            <stop offset="2.44966" stop-color="#C9D6E7">
                <animate attributeName="offset" values="-2; 2" dur="2s" repeatCount="indefinite"></animate>
            </stop>
            </linearGradient>
        </defs>
        </svg>
    </div>
</div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
